export const logger = (...args) => {
  return process.env.NODE_ENV === 'production' ? null : console.log(...args);
};
